import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import { PageHeader } from "../components/common";
import { FleetTab, TripsTab, ExpensesTab, RequisitionTab, StatementTab, ReportTab } from "../components/TruckParts";

const TABS = [
  ["fleet", "Fleet", FleetTab],
  ["trips", "Trip income", TripsTab],
  ["expenses", "Expenses", ExpensesTab],
  ["requisition", "Hardware supplies", RequisitionTab],
  ["statement", "Statement", StatementTab],
  ["report", "Report", ReportTab],
];

export default function Trucks() {
  return (
    <div className="space-y-6">
      <div className="no-print">
        <PageHeader eyebrow="Dar es Salaam · Truck fleet" title="Trucks" subtitle="Separate books for the truck business: trip income, truck expenses and supplies taken from the hardware store." />
      </div>
      <Tabs defaultValue="fleet" className="space-y-6">
        <TabsList className="no-print flex-wrap h-auto bg-slate-900 border border-slate-800">
          {TABS.map(([k, label]) => <TabsTrigger key={k} value={k} data-testid={`trucks-tab-${k}`}>{label}</TabsTrigger>)}
        </TabsList>
        {TABS.map(([k, , C]) => <TabsContent key={k} value={k}><C /></TabsContent>)}
      </Tabs>
    </div>
  );
}
